module.exports = [{
      plugin: require('/Users/huntermacd/Development/huntermacd_com_gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
